import React from 'react';

import { EventCartDetail, type EventCartDetailTypes } from '@nfctron/nexus-tickets';

import { Container } from '@mantine/core';

import { EventFooterAtom } from '@root/cart/_resources/atoms/EventFooter.atom';

import { type CountryEnumTicketsData } from '@root/lib/constants/country';
import { type OrganizerColorConfig } from '@root/lib/entities/organizer.entity';
import { type AtomComponent } from '@root/lib/types/components';

/**
 * Event/EventLayout component
 * @author filipditrich <ditrich@nfctron.com>
 * @constructor
 */
export const EventLayoutAtom: AtomComponent<EventLayoutAtomProps> = (props) => {
	const { children, organizerColors, ticketCompany, productCompany, ...rest } = props;

	return (
		<React.Fragment>
			{/* main container */}
			<Container size="responsive" className="flex max-w-screen-sm flex-col gap-3 px-0 py-0 sm:p-3 xl:max-w-screen-xl">
				{/* event header */}
				<div className="flex min-h-[70vh] flex-col gap-0 sm:gap-3 xl:flex-row">
					{/* event header */}
					<div className="max-w-full shrink grow xl:order-last xl:max-w-[456px] xl:min-w-[456px]">
						<EventCartDetail className="rounded-none sm:rounded-xl" {...rest} />
					</div>

					{/* main content container */}
					<div className="flex w-full flex-col xl:min-w-[675px]">{children}</div>
				</div>
			</Container>

			{/* event footer */}
			<EventFooterAtom
				ticketCompany={ticketCompany}
				productCompany={productCompany}
				organizerColors={organizerColors}
				organizerName={rest.organizerName}
				organizerLogoUrl={rest.organizerLogoUrl}
				eventName={rest.eventName}
			/>
		</React.Fragment>
	);
};

/**
 * Event/EventLayout atom component props
 * @export
 */
export interface EventLayoutAtomProps extends EventCartDetailTypes.Props {
	children: React.ReactNode;
	organizerColors: OrganizerColorConfig;
	ticketCompany: {
		legalName: string;
		address1?: string;
		address2?: string;
		city?: string;
		postalCode?: string;
		country: CountryEnumTicketsData;
		regNumber?: string;
		taxId?: string;
		vatId?: string;
	};
	productCompany: {
		legalName: string;
		address1?: string;
		address2?: string;
		city?: string;
		postalCode?: string;
		country: CountryEnumTicketsData;
		regNumber?: string;
		taxId?: string;
		vatId?: string;
	};
}

/**
 * Event/EventLayout atom display name
 * @type {ComponentDisplayName<"atom">>}
 */
EventLayoutAtom.displayName = 'Event/EventLayoutAtom';
